




import {Component, Vue} from 'vue-property-decorator';
import RouteNames from "@/router/RouteNames";

@Component({})
export default class Sales extends Vue {

  mounted(): void {
    if (this.$route.name === RouteNames.SALES) {
      this.$router.push({name: RouteNames.SALES_CATALOG});
    }
  }

}
